module.exports = __webpack_public_path__ + "static/media/sourcesanspro-light-webfont.5110c10b.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/sourcesanspro-light-webfont.ttf
// module id = 269
// module chunks = 0